export const getStored = <T>(key: string): T | undefined => {
  try {
    const result = localStorage.getItem(key);

    if (!result) {
      return undefined;
    }

    return JSON.parse(result) as T;
  } catch (e) {
    console.error(e);

    return undefined;
  }
};
